import React from 'react';

import FlexibleProductShowView from '@components/shared/flexible_products/FlexibleProductShowView';
import operatorFlexibleProductService from '@services/operator/flexibleProductService';
import { useLoaderData } from 'react-router-dom';

export default function OperatorFlexibleProductShow() {
  const flexibleProduct = useLoaderData();

  return (
    <FlexibleProductShowView
      flexibleProduct={flexibleProduct}
      service={operatorFlexibleProductService}
      role="operator"
    />
  );
}
